import axios from 'shared/tools/axiosMultisite';

export const getShortCode = async function getShortCode(url) {
	try {
		return await axios.get(url);
	} catch (err) {
		console.error(err);
	}
};
const ShortCodeSearchService = {
	getShortCode,
};

export default ShortCodeSearchService;
